import { IntlShape } from 'react-intl';
import * as Yup from 'yup';

export const getTestingDashBoardLoginFormSchema = (intl: IntlShape) => Yup.object({
  userId: Yup.string()
    .required(intl.formatMessage({ id: 'testing-dashboard-login.user-required' })),

  password: Yup.string()
    .min(4, intl.formatMessage({ id: 'testing-dashboard-login.password-length' }))
    .required(intl.formatMessage({ id: 'testing-dashboard-login.password-required' })),
});

export const GetTestingDashboardLoginFormInitialValue = (): ITestingDashboardLoginFormFields => ({
  userId: '',
  password: '',
});

export interface ITestingDashboardLoginFormFields {
  userId: string;
  password: string;
}
